<!-- eslint-disable vue/valid-template-root -->
<template />

<script>
// Global imports first, then import page components
import "../../styles/main.scss";
import CustomEventPolyfill from "../CustomEventPolyfill/CustomEventPolyfill.vue";
// import StartPage from "../StartPage/StartPage.vue";
import SubPage from "../SubPage/SubPage.vue";
import ProductDetailPage from "../ProductDetailPage/ProductDetailPage.vue";
import ProductFilterPage from "../ProductFilterPage/ProductFilterPage.vue";
import FAQPage from "../FAQPage/FAQPage.vue";
import GoogleMapsPage from "../GoogleMapsPage/GoogleMapsPage.vue";
import JobsListPage from "../JobsListPage/JobsListPage.vue";
import WorldWideListPage from "../WorldWideListPage/WorldWideListPage.vue";
import FlyersListPage from "../FlyersListPage/FlyersListPage.vue";
import ContactListPage from "../ContactListPage/ContactListPage.vue";
import BranchDetailPage from "../BranchDetailPage/BranchDetailPage.vue";
import SearchResultsPage from "../SearchResultsPage/SearchResultsPage.vue";
import CareerDetailPage from "../CareerDetailPage/CareerDetailPage.vue";
import NewsListPage from "../NewsListPage/NewsListPage.vue";
import ShopStartPage from "../ShopStartPage/ShopStartPage.vue";
import ShopProductDetailPage from "../ShopProductDetailPage/ShopProductDetailPage.vue";
import NewsletterForm from "../NewsletterForm/NewsletterForm.vue";
import RFQForm from "../RFQForm/RFQForm.vue";
import RotatingCarousel from "../RotatingCarousel/RotatingCarousel.vue";
import ProductAreaControlledCarousel from "../ProductAreaControlledCarousel/ProductAreaControlledCarousel.vue";
import FlipCard from "../FlipCard/FlipCard.vue";

export default {
  name: "Main"
};
</script>
